import { useEffect, useState } from "react";

import { DASHBOARD } from "./dashboard.query";
import { IDashboardResponse } from "./dashboard.interface";
import { toastMessageActions } from "../../state/request";
import { useDispatch } from "react-redux";
import { useLazyQuery } from "@apollo/client";

export const useDashboard = () => {
  const [dashboard, { data, loading, error }] = useLazyQuery<{ dashboard: IDashboardResponse }>(DASHBOARD, {
    fetchPolicy: "cache-and-network",
  });

  const dispatch = useDispatch();
  const [customError, setCustomError] = useState<any>();
  const [customLoading, setCustomLoading] = useState<boolean>(false);

  const getDashBoardData = async () => {
    setCustomLoading(true);
    try {
      await dashboard();
    } catch (err) {
      setCustomError(err);
      setCustomLoading(false);
    } finally {
      setCustomLoading(false);
    }
  };

  useEffect(() => {
    if (error) {
      setCustomError(error);
      dispatch(toastMessageActions.setGlobalAlert({
        severity: "error",
        message: `${error}`,
      }));
    }
  }, [error]);

  return {
    getDashBoardData,
    dashboard: data?.dashboard,
    loading,
    error,
    customError,
    customLoading,
  };
};
